// extracted by mini-css-extract-plugin
export default {"movieContainer":"MovieCard_movieContainer__gkvxi","respIframe":"MovieCard_respIframe__vgkJ7"};